import { render, staticRenderFns } from "./bullhornIcon.vue?vue&type=template&id=2175d354&"
import script from "./bullhornIcon.vue?vue&type=script&lang=js&"
export * from "./bullhornIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports